export const loginSignupFailMessages = {
    9000: "Invalid username or password.",
    9001: "Please provide e-mail to authenticate.",
    9002: "Please provide password to authenticate.",

    9010: "Something went wrong with the request. Please refresh and try again.",
    9011: "Something went wrong with the request. Please refresh and try again.",
    9012: "Something went wrong with the request. Please refresh and try again.",

    9020: "Something went wrong with the request. Please refresh and try again.",
    9021: "Something went wrong with the request. Please refresh and try again.",

    9030: "Something went wrong with the request. Please refresh and try again.",
    9031: "Something went wrong with the request. Please refresh and try again.",
    9032: "Something went wrong with the request. Please refresh and try again.",
    9033: "Something went wrong with the request. Please refresh and try again.",

    9040: "Something went wrong with the request. Please refresh and try again.",
    9041: "Something went wrong with the request. Please refresh and try again.",
    9042: "You don't have permission to access any subsidiary yet. Please contact the admin.",

    9051: "You are not allowed to perform this operation.",

    9060: "The provided ID does not match any user.",
    9061: "The user is already inactive.",
    9062: "The user is already active.",
    9063: "Please provide the user's e-mail.",
    9064: "Please provide the user's password.",
    9065: "Invalid user e-mail.",
    9066: "A user with the provided e-mail already exists.",
    9067: "Provided password is too common.",
    9068: "Provided password is too short.",
    9069: "Provided password is too simple.",
    9070: "Something went wrong with the request. Please refresh and try again.",
    9071: "Something went wrong with the request. Please refresh and try again.",

    9080: "The submited e-mail wasn't found. Please confirm the e-mail inserted.", // USERS_NON_EXISTING_USER
    9081: "Something went wrong with the request. Please refresh and try again.", // USERS_MULTIPLE_EXISTING_USERS

    9090: "Failed sending recovery email. Please try again later.", // USERS_PASSWORD_RECOVERY_MAIL_FAILED
    9091: "The number of password changes for this user reached it's limit", // USERS_PASSWORD_CHANGE_LIMIT_REACHED
    9092: "Something went wrong with the request. Please refresh and try again.", // USERS_PASSWORD_CODE_INVALID,
    //9073: "Máx. number of failed logins exceeded. Please contact the admin.",

    9073: "Unauthorized user edit.", //USERS_UNAUTHORIZED_EDIT
    9043: "", //AUTH_USER_FORBIDDEN_ACTION
    9093: "Account is blocked. Contact a system admin for further assistance.", //USERS_MAX_FAILED_LOGIN_ATTEMPTS
    1307: "Server type does not exist.", //SERVER_TYPE_DOES_NOT_EXIST
    1308: "Unable to open certificate file." //SERVER_CERTIFICATE_FILE_ERROR
};
